module.exports = __webpack_public_path__ + "static/hbkgzyy-2a3a0661b10f7d5709c5c765285709df.jpg";